import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core/styles';
import { V2GroupComponentDef } from '@terragotech/page-renderer';
import collapseImg from './img/Collapse.png';
import { PageControlProps } from '../PageTypes';
import { LabelSubText, ShrinkInfo } from './Common';
import _ from 'lodash';
import { CustomPageBadges } from './CustomPageBadges';

const GroupControl: FunctionComponent<PageControlProps<V2GroupComponentDef> & { name: string }> = ({
  controlDefinition,
  isPageEditor,
}) => {
  const theme = useTheme();
  const capitalizedControlType = _.upperFirst(controlDefinition.type);
  return (
    <Panel isPageEditor={isPageEditor} theme={theme}>
      <PanelHeader isPageEditor={isPageEditor} theme={theme}>
        {!isPageEditor && (
          <CollapseHolder theme={theme}>
            <img src={collapseImg} alt="Collapse Button" />
          </CollapseHolder>
        )}

        <PanelTitle isPageEditor={isPageEditor} theme={theme}>
          {controlDefinition.label}
        </PanelTitle>
        {isPageEditor && (
          <LabelSubText
            isGroup={true}
            isDisplayOptionsEnabled={Boolean(controlDefinition.displayOptions)}
            theme={theme}
          >
            <span>
              {capitalizedControlType}:{' '}
              {
                <ShrinkInfo theme={theme}>
                  {controlDefinition.template.rows} Row, {controlDefinition.template.columns}{' '}
                  Columns
                </ShrinkInfo>
              }
            </span>
          </LabelSubText>
        )}
        <SubSpan theme={theme}>
          <CustomPageBadges controlDefinition={controlDefinition} />
        </SubSpan>
      </PanelHeader>
    </Panel>
  );
};

const Panel = styled.div<{ isPageEditor?: boolean; theme?: any }>`
  margin-top: ${(props) => (props.isPageEditor ? '0px' : '8px')};
  background: ${({ theme }) => theme.palette.background.paper};
`;
const PanelHeader = styled.div<{ isPageEditor?: boolean; theme?: any }>`
  height: 22px; // should be 30 total
  padding-top: 8px;
  border-bottom: ${(props) =>
    props.isPageEditor ? 'none' : `1px solid ${props.theme.palette.divider}`};
  text-align: ${(props) => (props.isPageEditor ? 'left' : 'center')};
  text-transform: ${(props) => (props.isPageEditor ? 'none' : 'uppercase')};
  font-weight: 500;
  font-size: ${(props) => (props.isPageEditor ? '15px' : '12px')};
  line-height: 100%;
  color: ${(props) =>
    props.isPageEditor ? props.theme.palette.text.primary : props.theme.palette.text.secondary};
`;
const CollapseHolder = styled.div<{ theme?: any }>`
  position: absolute;
  margin-left: 10px;
`;
const PanelTitle = styled.div<{ isPageEditor?: boolean; theme?: any }>`
  display: flex;
  position: relative;
  margin-bottom: ${(props) => (props.isPageEditor ? '8px' : '0px')};
  color: ${({ theme }) => theme.palette.text.primary};
`;
const SubSpan = styled.div<{ theme?: any }>`
  margin-top: 12px;
`;
export default GroupControl;
